import { render, staticRenderFns } from "./CreateRideType.vue?vue&type=template&id=b596598a&"
import script from "./CreateRideType.vue?vue&type=script&lang=js&"
export * from "./CreateRideType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports